import { getCurrentAppByHostname } from '../Helpers';

const LOCAL_STORAGE_KEY = `Smartforce.${
  getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
} .AnalyticsInsights`;

export type AnalyticsInsightsType = 'contacts' | 'workspaces';
export interface AnalyticsInsightsProps {
  type: AnalyticsInsightsType;
  id: string | undefined;
}

export const getAnalyticsInsights = () => {
  const workspace = localStorage.getItem(LOCAL_STORAGE_KEY);
  return workspace ? JSON.parse(workspace) : null;
};

export const setAnalyticsInsights = (workspace: AnalyticsInsightsProps) => {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(workspace));
};

export const clearAnalyticsInsights = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
};

export const isAnalyticsInsightsSet = () => {
  return getAnalyticsInsights() !== null;
};
